import { useEffect } from 'react'
import './nameDialog.css'
import { GUID } from '../Services/ServiceTypes'
import { FolderNode, getNodeById } from '../WooNotes/folders'
import { WooNotesButton, WooNotesButtonColor, WooNotesButtonSize } from '../WooNotes/WooNotesButton'

type Props = {
  folderNodeId: GUID | undefined
  folderNodes: FolderNode[]
  onOK: () => void
  onCancel: () => void
}

export const ConfirmSetFolderItemUnlockedDialog = ({ folderNodeId, folderNodes, onOK, onCancel }: Props) => {
  useEffect(() => {
    if (!folderNodeId) return

    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onCancel()
    }

    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [folderNodeId, onCancel])

  if (!folderNodeId) return null

  const node = getNodeById(folderNodes, folderNodeId)
  if (!node) return null

  return (
    <div className="dialog-root">
      <div className="dialog-backdrop" onClick={onCancel} />

      <div className="dialog">
        <h3>{node?.name} is locked, are you sure you want to unlock it?</h3>

        <div className="actions">
          <WooNotesButton size={WooNotesButtonSize.Slim} color={WooNotesButtonColor.White} onClick={() => onCancel()}>Cancel</WooNotesButton>
          <WooNotesButton size={WooNotesButtonSize.Slim} color={WooNotesButtonColor.Blue} onClick={() => onOK()}>OK</WooNotesButton>
        </div>
      </div>
    </div>
  )
}
